/* External */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

/* Storage */
import { fetchVodContentMovieProgress } from '../storage/contents';

/* Utils */
import useGetCalculatedProgressByDuration from './useGetCalculatedProgressByDuration';
import { STATUS_TYPES } from '../utils/constants';
import useRequestAndDelete from './useRequestAndDelete';
import useContent from './useContent';
import { isEpisodeType } from '../utils/metaDataUtils';

export default function useFetchVodContentProgress({
  contentId,
  duration,
  isEpisode = false,
}) {
  const [requestId, setRequestId] = useState(undefined);
  const dispatch = useDispatch();
  const request = useRequestAndDelete(requestId);
  const content = useContent(contentId);
  const progressToReturn = useGetCalculatedProgressByDuration(content?.progress, duration);

  useEffect(() => {
    if (content) {
      const action = fetchVodContentMovieProgress(content.vmsId, content.vrioAssetId);

      setRequestId(action.requestId);

      if (!isEpisodeType(content.type)) {
        dispatch(action);
      }
    } else {
      setRequestId(undefined);
    }
  }, [dispatch, contentId, isEpisode, content]);

  if (duration === undefined && progressToReturn === undefined) {
    return { isCompleted: false, savedProgress: undefined };
  }

  const isCompleted = request?.status !== STATUS_TYPES.INIT_STATE
    || content?.progress !== undefined;

  return {
    isCompleted,
    savedProgress: duration && isCompleted ? progressToReturn : undefined,
  };
}
